import { getInterface } from '@/utils/js/initVariable';
const prefixUrl = 'api/RegionApi/';
export const getRegionPoint = (data)=>{
  return getInterface.post(`${prefixUrl}getRegionPoint`, data);
}
export const getBasicInformation = (data)=>{
  return getInterface.post(`${prefixUrl}getBasicInformation`, data);
}
export const getPackageBasic = (data)=>{
  return getInterface.post(`${prefixUrl}getPackageBasic`, data);
}
export const getPackageFreePoint = (data)=>{
  return getInterface.post(`${prefixUrl}getPackageFreePoint`, data);
}
export const addCustomRegion = (data)=>{
  return getInterface.post(`${prefixUrl}addCustomRegion`, data);
}
export const getRegionInformation = (data)=>{
  return getInterface.post(`${prefixUrl}getRegionInformation`, data);
}
export const packageRegionEcho = (data)=>{
  return getInterface.post(`${prefixUrl}packageRegionEcho`, data);
}
export const addPackageRegion = (data)=>{
  return getInterface.post(`${prefixUrl}addPackageRegion`, data);
}
export const getPackageRegionByFunctionId = (data)=>{
  return getInterface.post(`${prefixUrl}getPackageRegionByFunctionId`, data);
}
export const getPackageFreeRegionByFunctionId = (data)=>{
  return getInterface.post(`${prefixUrl}getPackageFreeRegionByFunctionId`, data);
}
export const getGPSJamData = (data)=>{
  return getInterface.post(`point/getGPSJamData`, data);
}
export const getNOTAMData = (data)=>{
  return getInterface.post(`point/getNOTAMData`, data);
}
export const getFixedGeoJson = (data)=>{
  return getInterface.post(`point/getFixedGeoJson`, data);
}
export const putCustomRegion = (data)=>{
  return getInterface.post(`${prefixUrl}putCustomRegion`, data);
}
export const queryCustomRegionList = (data)=>{
  return getInterface.post(`${prefixUrl}queryCustomRegionList`, data);
}
export const deleteCustomRegion = (data)=>{
  return getInterface.post(`${prefixUrl}deleteCustomRegion/${data}`, data);
}
// 每日侦照数据
export const getGlobalExposureDataByPermissionRegionToday = (data)=>{
  return getInterface.post(`${prefixUrl}getGlobalExposureDataByPermissionRegionToday`, data);
}
// 侦照数据基地查询
export const getAirBaseByRegion = (data)=>{
  return getInterface.post(`${prefixUrl}getAirBaseByRegion`, data);
}
// AI解读
export const analyzeRegionByLlmURL = (data)=>{
  return `stream/${prefixUrl}analyzeRegionByLlm`;
}
// 线索区数据
export const getPolygonClueArea = (data)=>{
  return getInterface.post(`${prefixUrl}getPolygonClueArea`, data);
}
// 自定义区域内线索区分析
export const shootingAreaAnalysis = (data)=>{
  return getInterface.post(`${prefixUrl}shootingAreaAnalysis`, data);
}
// 新增线索区
export const addPolygonClueArea = (data)=>{
  return getInterface.post(`${prefixUrl}addPolygonClueArea`, data);
}
// ai区域分析
export const queryLocationByQuestion = (data)=>{
  return `${prefixUrl}queryLocationByQuestion`;
}